import {
  BaseEnumerableResponse,
  PaymentDTO,
  PaymentType,
  Request,
  TipRequestDTO,
  FreezeRequestDTO,
} from "@campgladiator/cg-common.types.types";
import { fetchRequest } from "@campgladiator/cg-common.api.fetch-request";
import { getApiGatewayUrl } from "@campgladiator/cg-common.config.config";
import { generateQueryString } from "@campgladiator/cg-common.utility.objects";

const unknownErrorMessage = "An unknown error occurred";

export type FetchPaymentArgs = {
  trainerId?: string;
  workoutId?: number;
  userId?: string;
  type?: PaymentType;
  page?: number;
  size?: number;
  sort?: "ASC" | "DESC";
  token: string;
};

export const createTip = async (
  args: TipRequestDTO,
  token: string
): Promise<PaymentDTO> => {
  const endpoint = `/billing/v1/payments/tips`;
  const method = "POST";
  const body = JSON.stringify(args);

  try {
    const request: Request = {
      requestConfig: {
        authToken: token,
        method,
        url: { baseUrl: getApiGatewayUrl(), endpoint },
      },
      body,
    };
    const response = await fetchRequest({ request });
    const result = await response.json();
    return Promise.resolve(result);
  } catch (error: any) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || unknownErrorMessage;
    return Promise.reject(new Error(errorMessage));
  }
};

export const createFreezeFee = async (
  args: FreezeRequestDTO,
  token: string
): Promise<PaymentDTO> => {
  const endpoint = `/billing/v1/payments/freezes`;
  const method = "POST";
  const body = JSON.stringify(args);

  try {
    const request: Request = {
      requestConfig: {
        authToken: token,
        method,
        url: { baseUrl: getApiGatewayUrl(), endpoint },
      },
      body,
    };
    const response = await fetchRequest({ request });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error: any) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || unknownErrorMessage;
    throw new Error(errorMessage as string);
  }
};

export const fetchPayments = async (
  args?: FetchPaymentArgs
): Promise<BaseEnumerableResponse<PaymentDTO>> => {
  const endpoint = `/billing/v1/payments`;
  const method = "GET";
  const { token, ...rest } = args ?? {};
  const params = rest ? `?${generateQueryString(rest)}` : undefined;

  try {
    const request: Request = {
      requestConfig: {
        authToken: token,
        method,
        url: { baseUrl: getApiGatewayUrl(), endpoint, params },
      },
    };
    const response = await fetchRequest({ request });
    const result = await response.json();
    return Promise.resolve(result);
  } catch (error: any) {
    let errorMessage = error instanceof Error ? error.message : error;
    errorMessage = errorMessage || unknownErrorMessage;
    return Promise.reject(errorMessage);
  }
};
